import { DataTranscribeQueueActionTypes } from "../types";
import {
  IDataQueueResponse,
  ISearchQueuePagedResponse,
  IWorkflowItemStep,
  SearchQueuePagedRequest,
} from "../../../../common/sharedTypes";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import { toast } from "react-toastify";
import * as urls from "../../../shared/urls";

export const searchPaperReports = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(setPaperReports(response.data));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getPaperReports = async (
  url: string,
  request: SearchQueuePagedRequest
): Promise<ApiResponse<ISearchQueuePagedResponse>> => {
  return await Api.post(url, request);
};

export const searchPaperReportsPaged = (url: string, request: SearchQueuePagedRequest) => {
  return async (dispatch) => {
    try {
      dispatch(setLoadingWorkflowSteps(true));
      await getPaperReports(url, request).then(
        (response: ApiResponse<ISearchQueuePagedResponse>) => {
          dispatch(setPaperReports(response.data.workflowItems));
          dispatch(setTotalWorkflowSteps(response.data.totalResults));
        }
      );
    } catch (ex) {
      console.log(ex);
    } finally {
      dispatch(setLoadingWorkflowSteps(false));
    }
  };
};

export const setPaperReports = (workflowItems: IDataQueueResponse[]) => {
  return {
    type: DataTranscribeQueueActionTypes.SEARCH_REPORTS,
    value: workflowItems,
  };
};

export const setLoadingWorkflowSteps = (value: boolean) => {
  return {
    type: DataTranscribeQueueActionTypes.LOADING_WORKFLOW_STEPS,
    value: value,
  };
};

export const setTotalWorkflowSteps = (value: number) => {
  return {
    type: DataTranscribeQueueActionTypes.TOTAL_WORKFLOW_STEPS,
    value: value,
  };
};

export const openReport = (workflowItemStepId: number) => {
  return async (dispatch) => {
    try {
      await Api.post(urls.GET_WORKFLOW_ITEM_STEP, {
        workflowStepItemId: workflowItemStepId,
      }).then((result: ApiResponse<any>) => {
        dispatch(view(result.data));
        if (result.data == null) {
          toast.error("Error opening");
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscribeQueueActionTypes.OPEN_REPORT,
    value: workflowItemStep,
  };
};

export const assignAndOpen = (url, stepItemId, assignToId) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItemId,
        assignToUserId: assignToId,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceAssignAndOpen(result.data));
        if (result.data == null) {
          toast.error("Report already assigned");
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceAssignAndOpen = (itemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscribeQueueActionTypes.ASSIGN_AND_OPEN_REPORT,
    value: itemStep,
  };
};

export const unAssign = (url, stepItem) => {
  return async (dispatch) => {
    try {
      await Api.post(url, {
        workflowStepItemId: stepItem.id,
      }).then((result: ApiResponse<any>) => {
        dispatch(reduceUnAssign(result.data));
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceUnAssign = (itemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscribeQueueActionTypes.UNASSIGN,
    value: itemStep,
  };
};

export const completeDataTranscribe = (
  url: string,
  itemStep: IWorkflowItemStep,
  data: any,
  moveToNextWorkflow: boolean,
  assignNext: boolean
) => {
  return async (dispatch) => {
    try {
      return await Api.post(url, {
        workflowItemStepId: itemStep.id,
        data: JSON.stringify(data),
        moveToNextWorkflow: moveToNextWorkflow,
        assignNext: assignNext,
      }).then((result: ApiResponse<any>) => {
        if (!result.ok) {
          return Promise.reject(result);
        }

        // When assigning the next item, the response is the next workflow item step.
        if (assignNext && result.data) {
          dispatch(reduceComplete(result.data));
        }

        // Resolve with the response so callers can access the normalized report data.
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};
export const reduceComplete = (nextItemStep: IWorkflowItemStep) => {
  return {
    type: DataTranscribeQueueActionTypes.COMPLETE_DATA_ENTRY,
    value: nextItemStep,
  };
};
